import { InputBase } from '../../../classes/input-base';
import { InputSelect } from '../../../classes/input-select';
import { FeaturesStep4Form } from './features-step4-form';
import { InputText } from '../../../classes/input-text';
// import { GenreService } from '../../../core/services/data/genre.service';

// const genreService = new GenreService();

// const genres = genreService.genres();

export class FeaturesStep4FormNewInBooks extends FeaturesStep4Form {
	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Url',
		buttonSymbol: 'Go',
		required: true,
		blur: true,
	});

	apple = new InputBase({
		key: 'apple',
		label: 'Is your book available on Apple?',
		controlType: 'checkbox',
		value: false,
	});

	appleLink = new InputText({
		key: 'appleLink',
		label: 'Apple URL',
	});

	kobo = new InputBase({
		key: 'kobo',
		label: 'Is your book available on Kobo?',
		controlType: 'checkbox',
		value: false,
	});

	koboLink = new InputText({
		key: 'koboLink',
		label: 'Kobo URL',
	});

	nook = new InputBase({
		key: 'nook',
		label: 'Is your book available on Nook?',
		controlType: 'checkbox',
		value: false,
	});

	nookLink = new InputText({
		key: 'nookLink',
		label: 'Nook URL',
	});

	googleplay = new InputBase({
		key: 'googleplay',
		label: 'Is your book available on Google Play?',
		controlType: 'checkbox',
		value: false,
	});

	googleplayLink = new InputText({
		key: 'googleplayLink',
		label: 'Google Play URL',
	});

	description = new InputBase({
		key: 'description',
		label: 'Book Description for Promotion',
		controlType: 'textarea',
		maxLength: 400,
		infoLabel: '(Must be 350 characters or less. Please don\'t copy from Amazon.)',
	});

	bookGenres = new InputSelect({
		key: 'bookGenres',
		label: 'Book Genre',
		options: [
			{ key: '-- Select a Genre --', value: '', disabled: true },
			// ...genres,
		],
	});

	kindleUnlimited = new InputBase({
		key: 'kindleUnlimited',
		label: 'Is your book enrolled in Kindle Unlimited?',
		controlType: 'checkbox',
	});

	bookPriceDuringPromo = new InputText({
		key: 'bookPriceDuringPromo',
		label: 'Book Price During Promotion',
		required: true,
		type: 'number',
		addonSymbol: '$',
		min: 0,
	});
}
